export const BILLIN_LINE_DEEP_LINK =
  process.env.NEXT_PUBLIC_BILLIN_LINE_DEEP_LINK?.trim() ?? "";
